import { ROUTE__auth } from '@/hooks/routes/ROUTE__auth';
import { ROUTE__private } from '@/hooks/routes/ROUTE__private';
import { ROUTE__public } from '@/hooks/routes/ROUTE__public';
import { PageDiffusionModels } from '@/pages/page_diffusion_models/page_diffusion_models';
import { PageOpenPose } from '@/pages/page_open_pose/PageOpenPose';
import { PageReservations } from '@/pages/page_reservations/page_reservations';
import { PageWorkspaceInvitation } from '@/pages/page_workspace_invitation/PageWorkspaceInvitation';
import { useRoutes } from 'react-router-dom';
import { PageAdmin } from '../_admin/page_admin/PageAdmin';
import { ENUM__page_type as E } from '../enums/ENUM__page_type';
import { S_PAGE__settings_user } from '../pages/+settings/user/S_PAGE__settings_user';
import { PageSettingsWorkspace } from '../pages/+settings/workspace/PageSettingsWorkspace';
import { A_PAGE__auth } from '../pages/page_auth/A_PAGE__auth';
import { PAGE__auth_verify_email_and_login } from '../pages/page_auth_verify_email_and_login/PAGE__auth_verify_email_and_login';
import { PAGE__auth_with_magic_link } from '../pages/page_auth_with_magic_link/PAGE__auth_with_magic_link';
import { C_PAGE__collections } from '../pages/page_collections/C_PAGE__collections';
import { G_PAGE__generation } from '../pages/page_generation/G_PAGE__generation';
import { PageSearch } from '../pages/page_search/PageSearch';
import { PageStripeCheckoutResult } from '../pages/page_stripe_checkout_result/PageStripeCheckoutResult';
import { PAGE__404 } from '../pages/page_system/PAGE__404';
import { U_PAGE__user_task } from '../pages/page_user_task/U_PAGE__user_task';

export function APP__routes() {
  return useRoutes([
    ROUTE__public(E.ANY, <PAGE__404 />),

    /*
     * AUTH ROUTES
     */

    ROUTE__auth(E.AUTH_WITH_MAGIC_LINK, <PAGE__auth_with_magic_link />),
    ROUTE__auth(E.AUTH, <A_PAGE__auth />),
    ROUTE__auth(E.AUTH_VERIFY_EMAIL_AND_LOGIN, <PAGE__auth_verify_email_and_login />),

    /*
     * OTHER ROUTES
     */

    ROUTE__private(E.MAIN, <A_PAGE__auth />),

    ROUTE__public(E.COLLECTIONS, <C_PAGE__collections />),
    ROUTE__private(E.COLLECTIONS_WITHOUT_PARAMS, <C_PAGE__collections />),

    ROUTE__private(E.DIFFUSION_MODELS_WITHOUT_PARAMS, <PageDiffusionModels />),
    ROUTE__private(E.DIFFUSION_MODELS, <PageDiffusionModels />),

    ROUTE__private(E.RESERVATIONS_WITHOUT_PARAMS, <PageReservations />),
    // use_route_ud_private(E.RESERVATIONS, <PageDiffusionModels />),

    ROUTE__public(E.USER_TASK, <U_PAGE__user_task />),
    ROUTE__private(E.USER_TASK_WITHOUT_PARAMS, <U_PAGE__user_task />),

    ROUTE__public(E.GENERATION, <G_PAGE__generation />),
    ROUTE__private(E.GENERATION_WITHOUT_PARAMS, <G_PAGE__generation />),

    ROUTE__private(E.OPEN_POSE_WITHOUT_PARAMS, <PageOpenPose />),

    ROUTE__public(E.SEARCH, <PageSearch />),
    ROUTE__private(E.SEARCH_WITHOUT_PARAMS, <PageSearch />),

    ROUTE__private(E.SETTINGS_USER, <S_PAGE__settings_user />),

    ROUTE__private(E.SETTINGS_WORKSPACE, <PageSettingsWorkspace />),
    ROUTE__private(E.SETTINGS_WORKSPACE_WITHOUT_PARAMS, <PageSettingsWorkspace />),

    ROUTE__private(E.WORKSPACE_INVITATION, <PageWorkspaceInvitation />),

    ROUTE__public(E.STRIPE_CHECKOUT_RESULT, <PageStripeCheckoutResult />),

    /*
     * ADMIN ROUTES
     */
    ROUTE__private(E.ADMIN, <PageAdmin />),
  ]);
}
